// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Client from "@apollo/client";
import * as Stylex from "@stylexjs/stylex";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as InputOptionalNumberField from "../../resources/selection-and-input/InputOptionalNumberField.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";
let styles = {
  wrapper: {
    "display-k1xSpc": "display-x78zum5",
    "flex-kUk6DE": "flex-x98rzlu",
    $$css: "wino-gc:src/modules/Catalog/CatalogPriceLookUpInput.res.js:18"
  },
  button: {
    "paddingLeft-kE3dHu": "paddingLeft-x163pfp",
    $$css: "wino-gc:src/modules/Catalog/CatalogPriceLookUpInput.res.js:22"
  }
};
function buttonStyleFromParams(errored) {
  if (errored) {
    return {
      alignSelf: "center",
      top: "2px"
    };
  } else {
    return {
      alignSelf: "flex-end"
    };
  }
}
let Raw = {};
let query = Client.gql(["query variantsPriceLookUpCodes($shopId: String!)  {\nvariantsPriceLookUpCodes(shopId: $shopId)  \n}\n"]);
function parse(value) {
  let value$1 = value.variantsPriceLookUpCodes;
  return {
    variantsPriceLookUpCodes: value$1.map(value => value)
  };
}
function serialize(value) {
  let value$1 = value.variantsPriceLookUpCodes;
  let variantsPriceLookUpCodes = value$1.map(value => value);
  return {
    variantsPriceLookUpCodes: variantsPriceLookUpCodes
  };
}
function serializeVariables(inp) {
  return {
    shopId: inp.shopId
  };
}
function makeVariables(shopId, param) {
  return {
    shopId: shopId
  };
}
let ConsummedPriceLookUpCodesQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};
let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});
let use = include.use;
let ConsummedPriceLookUpCodesQuery_refetchQueryDescription = include.refetchQueryDescription;
let ConsummedPriceLookUpCodesQuery_useLazy = include.useLazy;
let ConsummedPriceLookUpCodesQuery_useLazyWithVariables = include.useLazyWithVariables;
let ConsummedPriceLookUpCodesQuery = {
  ConsummedPriceLookUpCodesQuery_inner: ConsummedPriceLookUpCodesQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  refetchQueryDescription: ConsummedPriceLookUpCodesQuery_refetchQueryDescription,
  use: use,
  useLazy: ConsummedPriceLookUpCodesQuery_useLazy,
  useLazyWithVariables: ConsummedPriceLookUpCodesQuery_useLazyWithVariables
};
function makeValue(alreadyConsummedValues, pluRangeOpt, param) {
  let pluRange = pluRangeOpt !== undefined ? pluRangeOpt : [1, 9997];
  return Stdlib_Option.mapOr(Stdlib_Array.fromInitializer((pluRange[1] - pluRange[0] | 0) + 1 | 0, index => index + 1 | 0).find(plu => !alreadyConsummedValues.some(current => current === plu)), {
    TAG: "Error",
    _0: undefined
  }, plu => ({
    TAG: "Ok",
    _0: plu
  }));
}
function CatalogPriceLookUpInput(props) {
  let onChange = props.onChange;
  let onAlreadyConsummedValuesFetched = props.onAlreadyConsummedValuesFetched;
  let errorMessage = props.errorMessage;
  let value = props.value;
  let originalPluRef = React.useRef(value);
  let shopId = Stdlib_Option.map(Auth.useActiveShop(), shop => shop.id);
  let queryResults = use(undefined, undefined, undefined, undefined, "CacheAndNetwork", undefined, undefined, undefined, undefined, undefined, undefined, undefined, Stdlib_Option.isNone(shopId), undefined, {
    shopId: Stdlib_Option.getOr(shopId, "")
  });
  let match = queryResults.data;
  let alreadyConsummedValues = match !== undefined ? match.variantsPriceLookUpCodes.filter(plu => plu !== originalPluRef.current) : [];
  ReactUpdateEffect.use1(() => {
    let match = queryResults.data;
    if (alreadyConsummedValues.length !== 0 || match !== undefined) {
      onAlreadyConsummedValuesFetched(alreadyConsummedValues);
    }
  }, [queryResults]);
  let onPressGeneratePlu = React.useCallback(() => {
    Stdlib_Result.map(makeValue(alreadyConsummedValues, undefined, undefined), plu => onChange(plu));
  }, [alreadyConsummedValues]);
  let onChange$1 = value => onChange(Stdlib_Option.map(value, prim => prim | 0));
  let generatePluButtonDisabled = queryResults.loading || Stdlib_Option.isNone(shopId);
  let newrecord = {
    ...{
      className: "display-x78zum5 flex-x98rzlu",
      "data-style-src": "wino-gc:src/modules/Catalog/CatalogPriceLookUpInput.res.js:18"
    }
  };
  let newrecord$1 = {
    ...Stylex.props(styles.button, buttonStyleFromParams(Stdlib_Option.isSome(errorMessage)))
  };
  newrecord.children = [JsxRuntime.jsx(InputOptionalNumberField.make, {
    value: Stdlib_Option.map(value, prim => prim),
    minValue: 1,
    maxValue: 9997,
    precision: 0,
    label: I18n.t("PLU code"),
    errorMessage: errorMessage,
    placeholder: queryResults.loading ? I18n.t("Loading") + "..." : "1-9997",
    disabled: queryResults.loading,
    useGrouping: false,
    onChange: onChange$1
  }), JsxRuntime.jsx("div", (newrecord$1.children = JsxRuntime.jsx(Button.make, {
    label: I18n.t("Generate code"),
    disabled: generatePluButtonDisabled,
    onPress: onPressGeneratePlu
  }), newrecord$1))];
  return JsxRuntime.jsxs("div", newrecord);
}
let make = React.memo(CatalogPriceLookUpInput);
let pluRange = [1, 9997];
export { pluRange, styles, buttonStyleFromParams, ConsummedPriceLookUpCodesQuery, makeValue, make };
/* styles Not a pure module */